class MobileMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    const drawer = document.querySelector('site-drawer[key="menu"]')
    const drawerNavLinks = drawer.querySelectorAll('[data-gtm-nav-link]')

    drawerNavLinks.forEach((el) => {
      el.addEventListener('click', this.handleDrawerNavClick.bind(this))
    })
  }

  handleDrawerNavClick (e) {
    e.stopImmediatePropagation()

    const target = e.currentTarget
    const targetLevel = target.closest('[data-gtm-target-level]')
    const targetContext = target.closest('[data-gtm-target-context]')
    const targetElement = target.closest('[data-gtm-target-element]')

    window.dataLayer.push({
      event: 'nav_link_click_drawer',
      target_text: target.dataset.gtmTargetText || target.innerText,
      target_level: targetLevel?.dataset.gtmTargetLevel,
      target_context: targetContext?.dataset.gtmTargetContext,
      target_element: targetElement?.dataset.gtmTargetElement || 'link',
    })
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu)
}